module.exports = __webpack_public_path__ + "media/images/conference-1-7985c16a671f7d5a02c64e5c509b3e76.jpg";